var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ControlContainer } from '@angular/forms';
import { AbstractDwFormItemComponent } from '../../form-field/abstract-dw-form-item-component';
import { TranslateParser } from '@ngx-translate/core';
var DwFormInputComponent = /** @class */ (function (_super) {
    __extends(DwFormInputComponent, _super);
    function DwFormInputComponent(_fg, _ts) {
        var _this = _super.call(this, _fg, _ts) || this;
        _this._fg = _fg;
        _this._ts = _ts;
        _this.dwSize = 'default';
        _this.dwType = 'text';
        _this.dwDisabled = false;
        return _this;
    }
    DwFormInputComponent.prototype.afterContentInit = function () { };
    DwFormInputComponent.prototype.change = function (event) {
        this.onChange(event.target.value);
    };
    DwFormInputComponent.prototype.onInit = function () { };
    return DwFormInputComponent;
}(AbstractDwFormItemComponent));
export { DwFormInputComponent };
